import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

export default function ToolTip({ content, children, position="bottom", tooltipTestId, ...props }){

    return(
        <Tooltip
            title={tooltipTestId ? undefined : content}
            position={position}
            popperOptions={{
                modifiers: {
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'window', // ✅ Use 'window' instead of 'viewport'
                    },
                    flip: {
                        enabled: true,
                        behavior: ['top', 'bottom', 'right', 'left'], // ✅ Popper v1 expects 'behavior'
                    },
                },
            }}
            arrow="true"
            arrowSize="regular"
            html={
                tooltipTestId ? (
                    <div data-testid={tooltipTestId}>{content}</div>
                ) : undefined
            }
            {...props}
        >
            {children}
        </Tooltip>
    );
}